<test-core-resizable-layout>
  <div top-content>
    <test-core-header-tools>
      <div>TEST APP: Top Bar ( NOT JMKW )</div>
    </test-core-header-tools>
  </div>
  <div left-content>
    <div class="rotated-text left">TEST APP: Left Bar ( NOT JMKW )</div>
  </div>
  <div main-content>
    <!-- START: JMKW -->
    <jmkw
      id="jmkw"
      [pluginMap]="(userDefinedPluginMap$ | async)!"
      [configuration]="pluginConfigurationMap"
      (mapLoaded)="onMapLoaded($event)"
      (viewsLoaded)="onViewsLoaded($event)"
      (layersLoaded)="onLayersLoaded($event)"
      (initialized)="onInitialized($event)"
      (pluginsUpdated)="onPluginsUpdated($event)"
    >
    </jmkw>
    <!-- END: JMKW -->
  </div>
  <div right-content>
    <div class="rotated-text right">TEST APP: Right Bar ( NOT JMKW )</div>
  </div>
  <div bottom-content>TEST APP: Bottom Bar ( NOT JMKW )</div>
</test-core-resizable-layout>
